// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Gh_AM","title":"FrontImage_title__8dXWW"};